import { useNavigate } from 'react-router-dom';
import HeaderActions from './HeaderActions';
import { Icons } from '@/utils/Icons';
import AuthModal from './AuthModal';
import Cookies from 'js-cookie';
import { useGetContactSupportQuery } from '@/store/api/userApi';

const Header = ({ collapse, onToggle }: { collapse: boolean; onToggle: () => void }) => {
  const navigate = useNavigate();
  const loggedIn = Cookies.get('access-token');
  const { data } = useGetContactSupportQuery();
  return (
    <header className="sticky top-0 z-[1000] w-full bg-[#25252E]">
      <div className="h-[44px] flex items-center justify-between">
        {/* Left Section */}
        <div className="flex items-center gap-3">
          {collapse ? (
            <button onClick={onToggle} className="flex flex-col justify-between h-[16px]">
              <span className="block w-[18px] h-[2px] bg-white rounded"></span>
              <span className="block w-[11px] h-[2px] bg-white rounded"></span>
              <span className="block w-[14px] h-[2px] bg-white rounded"></span>
            </button>
          ) : (
            <>
              <Icons.Cross size={24} onClick={onToggle} className="2xl:hidden cursor-pointer" />
              <button
                onClick={onToggle}
                className="flex flex-col justify-between h-[16px] max-2xl:hidden"
              >
                <span className="block w-[18px] h-[2px] bg-white rounded"></span>
                <span className="block w-[11px] h-[2px] bg-white rounded"></span>
                <span className="block w-[14px] h-[2px] bg-white rounded"></span>
              </button>
            </>
          )}

          {/* Logo */}
          <div onClick={() => navigate('/')} className="flex items-center">
            <img
              src="/logo.png"
              alt="Ultrabet777"
              className="h-[28px] object-contain cursor-pointer"
            />
          </div>
        </div>
        {/* Right Section */}
        {!loggedIn ? (
          <div className="flex items-center gap-2">
            {/* Login Button */}
            <button
              onClick={() => navigate('?mode=login')}
              className="bg-primary text-black text-[11px] lg:text-xs font-bold px-[15px] py-[6px] rounded shadow-md tracking-wide h-8"
            >
              LOGIN
            </button>

            {/* Register Button */}
            <button
              onClick={() => navigate('?mode=register')}
              className="bg-[#00B24B] text-black text-[11px] lg:text-xs font-bold px-[15px] py-[6px] rounded shadow-md tracking-wide h-8"
            >
              REGISTER
            </button>
          </div>
        ) : (
          <HeaderActions />
        )}
      </div>
      <AuthModal />
    </header>
  );
};

export default Header;
